import { render, staticRenderFns } from "./specialCourse.vue?vue&type=template&id=dd63f94a&scoped=true"
import script from "./specialCourse.vue?vue&type=script&lang=js"
export * from "./specialCourse.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=dd63f94a&prod&scoped=true&lang=css&external"
import style1 from "./specialCourse.vue?vue&type=style&index=1&id=dd63f94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd63f94a",
  null
  
)

export default component.exports